import { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@utils'
import { ValueTrend } from '@types'
import { ArrowDownLightIcon, ArrowUpLightIcon } from '@components/icons/light'

type Props = HTMLAttributes<HTMLDivElement> & {
  value: number
  hardcoded?: boolean
  variant?: 'light' | 'dark' | 'filled'
}
type Metadata = { icon?: ReactNode; sign?: string }

const metadata: Record<ValueTrend, Metadata> = {
  decreasing: {
    icon: <ArrowDownLightIcon width={16} height={16} />,
  },
  rising: {
    icon: <ArrowUpLightIcon width={16} height={16} />,
    sign: '+',
  },
  none: {},
}

export function PercentageChangeTag({ value, className, ...props }: Props) {
  const valueTrend: ValueTrend =
    value === 0 ? 'none' : value > 0 ? 'rising' : 'decreasing'

  const { icon, sign } = metadata[valueTrend]

  if (value === 0) {
    return null
  }

  return (
    <div
      className={cn(
        'flex items-center rounded-2xl p-1 px-2 text-sm absolute right-3 font-normal',

        props.variant === 'light'
          ? {
              'border border-[0.5px] border-cw-system-red/[0.5] text-cw-system-red':
                value < 0,
              'border border-cw-electric-purple border-[0.5px] text-cw-electric-purple':
                value === 0,
              'border border-[0.5px] border-cw-eucal-green/[0.5] text-cw-eucal-green':
                value > 0,
              hardcoded: props.hardcoded,
            }
          : props.variant === 'dark'
            ? {
                'border border-[0.5px] border-cw-system-red/[0.5] text-cw-system-red':
                  value < 0,
                'border border-cw-electric-purple border-[0.5px] text-cw-electric-purple':
                  value === 0,
                'border border-[0.5px] border-cw-eucal-green/[0.5] text-cw-eucal-green':
                  value > 0,
                hardcoded: props.hardcoded,
              }
            : {
                'border border-[0.5px] border-cw-system-red/[0.5] bg-cw-system-red text-cw-deep-purple-dark':
                  value < 0,
                'border border-cw-electric-purple border-[0.5px] bg-cw-electric-purple text-white':
                  value === 0,
                'border border-[0.5px] border-cw-eucal-green/[0.5] bg-cw-eucal-green text-cw-deep-purple-dark':
                  value > 0,
                hardcoded: props.hardcoded,
              },
        className,
      )}
      {...props}
    >
      {sign}
      {value}%<span className="ml-1">{icon}</span>
    </div>
  )
}
